export default __webpack_public_path__ + "static/media/upgrade.e8ef1edf.svg";